/**
 * Cart page (sections/cart.liquid) quantity syncing - updates the line
 * price and cart total live via /cart/change.js as soon as the quantity
 * changes, no separate "Update" click needed. The -/+ button handling
 * itself lives in assets/quantity-stepper.js (shared with the product
 * page) - that script adjusts the input's value and dispatches a 'change'
 * event, which is all this file listens for, so it doesn't matter whether
 * that change came from typing directly or from the stepper buttons.
 *
 * The quantity input keeps its normal name="updates[...]" as a field of
 * the surrounding {% form 'cart' %}, so it's still correctly applied even
 * if this script fails to load or a request doesn't finish before the
 * customer submits (Continue to Checkout) - this is a progressive
 * enhancement on top of that, not the only way a quantity change reaches
 * Shopify.
 *
 * Money is never formatted in JS here - /cart/change.js only returns
 * unformatted cent totals, and reimplementing the shop's money format
 * correctly (currency symbol placement, multi-currency, etc.) is real
 * complexity and real risk of getting it wrong. Instead, once a quantity
 * change is confirmed, this re-fetches this same section's own rendered
 * HTML via Shopify's Section Rendering API (?sections=<section-id>) and
 * copies the already-correctly-formatted price/total text out of that
 * fresh markup - genuine Liquid output, not a reimplementation of it.
 */
(function () {
  var wrapper = document.querySelector('[data-cart-form]');
  if (!wrapper) return;

  var sectionId = wrapper.getAttribute('data-section-id');

  function refreshPrices(key) {
    if (!sectionId) return;

    fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId))
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;

        var fresh = new DOMParser().parseFromString(html, 'text/html');

        // innerHTML, not textContent: the price cell can now hold a
        // struck-through original price next to the final one when the
        // line has a discount, and the promo block (tag label + "Then
        // $X/month") can change with quantity too - copying text only
        // would flatten both. Still genuine Liquid output, not
        // reformatted here.
        var freshPrice = fresh.querySelector('[data-item-price][data-key="' + key + '"]');
        var livePrice = document.querySelector('[data-item-price][data-key="' + key + '"]');
        if (freshPrice && livePrice) livePrice.innerHTML = freshPrice.innerHTML;

        var freshPromo = fresh.querySelector('[data-item-promo][data-key="' + key + '"]');
        var livePromo = document.querySelector('[data-item-promo][data-key="' + key + '"]');
        if (freshPromo && livePromo) livePromo.innerHTML = freshPromo.innerHTML;

        var freshTotal = fresh.querySelector('[data-cart-total]');
        var liveTotal = document.querySelector('[data-cart-total]');
        if (freshTotal && liveTotal) liveTotal.textContent = freshTotal.textContent;
      });
    // No .catch() UI here - a failed refresh just leaves the old price
    // showing; the real quantity change already succeeded server-side
    // and will show correctly next time the page loads or submits.
  }

  function setQuantity(key, quantity, input) {
    quantity = Math.max(1, quantity);
    input.value = quantity;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (response) {
      if (response.ok) refreshPrices(key);
    });
  }

  wrapper.addEventListener('change', function (event) {
    var input = event.target.closest('[data-qty-input]');
    if (!input) return;

    var next = parseInt(input.value, 10) || 1;
    setQuantity(input.getAttribute('data-key'), next, input);
  });
})();
